module.exports = __webpack_public_path__ + "img/Kaspar Wetlism.3ac98730.jpg";